// Static image generator for can labels
// Creates a metallic texture with composited label image

let sourceImage = null;
let generatedImageUrl = null;
let metallicBase = null;

// Load metallic base texture
const metallicBaseImg = new Image();
metallicBaseImg.src = '/canlabels/metallic_base_rough.jpg';

export function setSourceImage(imageSrc) {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => {
            sourceImage = img;

            // Ensure metallic base is loaded
            if (!metallicBase && metallicBaseImg.complete) {
                metallicBase = metallicBaseImg;
            }

            resolve(img);
        };
        img.onerror = reject;
        img.src = imageSrc;
    });
}

// Ensure metallic base loads
metallicBaseImg.onload = () => {
    metallicBase = metallicBaseImg;
};

export function generateTexture(offsetXPercent, offsetYPercent, scale) {
    if (!sourceImage) {
        return null;
    }

    // Scale determines what percentage of the canvas the base image fills
    // Canvas size = base image width / (scale / 100)
    // At 100%: image fills entire canvas width
    // At 50%: image fills half the canvas, rest is gray
    const scaleFactor = scale / 100;
    const canvasSize = Math.round(sourceImage.naturalWidth / scaleFactor);

    // Calculate pixel offsets from percentages (based on canvas size)
    const offsetX = Math.round((offsetXPercent / 100) * canvasSize);
    const offsetY = Math.round((offsetYPercent / 100) * canvasSize);

    // Create temporary canvas for generation
    const canvas = document.createElement('canvas');
    canvas.width = canvasSize;
    canvas.height = canvasSize;

    // Use srgb colorspace to match exported images
    const ctx = canvas.getContext('2d', { colorSpace: 'srgb' });

    // Disable image smoothing for pixel-perfect rendering
    ctx.imageSmoothingEnabled = false;

    // Tile metallic base texture to fill canvas
    if (metallicBase) {
        const baseWidth = metallicBase.naturalWidth;
        const baseHeight = metallicBase.naturalHeight;

        // Tile the metallic base across the entire canvas
        for (let y = 0; y < canvasSize; y += baseHeight) {
            for (let x = 0; x < canvasSize; x += baseWidth) {
                ctx.drawImage(metallicBase, x, y);
            }
        }
    } else {
        // Fallback to gray if metallic base not loaded
        ctx.fillStyle = '#C0C0C0';
        ctx.fillRect(0, 0, canvasSize, canvasSize);
    }

    // Draw base image PIXEL-FOR-PIXEL at offset position (NO SCALING)
    ctx.drawImage(
        sourceImage,
        offsetX,
        offsetY,
        sourceImage.naturalWidth,
        sourceImage.naturalHeight
    );

    // Convert to data URL
    const dataUrl = canvas.toDataURL('image/png');

    // Clean up old URL
    if (generatedImageUrl && generatedImageUrl.startsWith('blob:')) {
        URL.revokeObjectURL(generatedImageUrl);
    }

    generatedImageUrl = dataUrl;
    return dataUrl;
}

export function getGeneratedImageUrl() {
    return generatedImageUrl;
}

export function clearAll() {
    sourceImage = null;
    if (generatedImageUrl && generatedImageUrl.startsWith('blob:')) {
        URL.revokeObjectURL(generatedImageUrl);
    }
    generatedImageUrl = null;
}
